import React, { Component, Fragment} from "react";
import { getParams, end_point, makeUniqueKey, applyOrganizationTheme, PROGRAM_TYPE_BUCKETS, getProgramTypeBucketLabel, normalizeProgramTypeBucket, getDefaultProgramTypeLabels, getDefaultEmailTemplates, normalizeEmailTemplates } from './helper';
import HamburgerNavbar from './hamburgerNavbar';
import { FormGroup, ControlLabel, FormControl, Button, Image, Row, Col, InputGroup, Tabs, Tab } from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faTimes, faCheck,faInfoCircle } from '@fortawesome/free-solid-svg-icons'
var $ = require('jquery')

const MERCH_SLOT_COUNT = 3
const createDefaultMerchSlots = () => Array.from({ length: MERCH_SLOT_COUNT }, () => ({
  name: '',
  logo: '',
}))

const createDefaultPaymentCredentials = () => ({
  gateway: 'converge',
  account: '',
  currency_type: 'CAD',
  ssl_merchant_id: '',
  ssl_user_id: '',
  ssl_pin: '',
})

class organizationForm extends Component {
  constructor() {
    super();
    const storedToken = typeof window !== 'undefined' ? localStorage.getItem('jwt') : ''
    const organizationId = localStorage.getItem("organization_id")
    const savedActiveTab = organizationId ? localStorage.getItem(`organizationForm.activeTab.${organizationId}`) : null
    this.state = {
      address: '',
      addUDF: false,
      description: '',
      email: '',
      enrolment_emails: '',
      enrolEmails: '',
      token: getParams().jwt || storedToken || '',
      id: '',
      name: '',
      phone: '',
      logo: '',
      navbar_color: '#5563b8',
      navbar_text_color: '#ffffff',
      landingPageGradientStart: '#0f172a',
      landingPageGradientEnd: '#172033',
      landingPageHeroText: '',
      landingPageHeroSubheading: '',
      programTypeLabels: [],
      emailTemplates: getDefaultEmailTemplates(),
      selectedEmailTemplateKey: 'parent_registration_confirmation',
      addProgramType: false,
      programTypeLabel: '',
      programTypeBucket: 'league',
      waiver: '',
      travelWaiver: '',
      merch: createDefaultMerchSlots(),
      paymentCredentials: createDefaultPaymentCredentials(),
      venues: [],
      venueName: '',
      venueStreetAddress1: '',
      venueStreetAddress2: '',
      venueCity: '',
      venueRegion: '',
      venuePostalCode: '',
      venueCountry: 'Canada',
      organization_id: localStorage.getItem("organization_id"),
      endpoint: `${end_point('organizations')}/organizations`,
      UDFs: [],
      spinner: false,
      confirm: false,
      logoChanged: false,
      merchChanged: false,
      billingHistory: [],
      billingLoading: false,
      activeTab: savedActiveTab || 'business',
      udfTypeHint: false
    };
    this.confirmResetTimer = null
    this.hamburgerKey = "hamburger"
    this.programTypeLabelsDraft = []
    this.emailTemplatesDraft = getDefaultEmailTemplates()
  }

  normalizeMerch = (merch = []) => {
    const normalized = createDefaultMerchSlots()
    return normalized.map((_, index) => {
      const entry = merch[index] || {}
      return {
        name: entry.name || '',
        logo: entry.logo || '',
      }
    })
  }

  normalizePaymentCredentials = (paymentCredentials = {}) => ({
    ...createDefaultPaymentCredentials(),
    ...(paymentCredentials || {}),
  })

  componentWillUnmount() {
    if (this.confirmResetTimer) {
      clearTimeout(this.confirmResetTimer)
    }
  }

  componentDidMount() {
    $.ajax({
        headers: {
            "token": this.state.token,
            "organization_id": this.state.organization_id
        },
        method: "GET",
        dataType: "json",
        url: this.state.endpoint,
    }).then((resp) => {
      this.organizationsGetHandler(resp)
      this.loadBillingHistory()
    })
  }

  organizationsGetHandler = (resp) => {
    console.log('org info', resp)
    const normalizedProgramTypeLabels = this.normalizeProgramTypeLabels(resp.program_type_labels ? resp.program_type_labels : [])
    const normalizedEmailTemplates = normalizeEmailTemplates(resp.email_templates ? resp.email_templates : {})
    const normalizedMerch = this.normalizeMerch(resp.merch ? resp.merch : [])
    const normalizedPaymentCredentials = this.normalizePaymentCredentials(resp.payment_credentials ? resp.payment_credentials : {})
    const venues = Array.isArray(resp.venues) ? resp.venues : []
    this.setState({
      id: resp._id,
      name: resp.name,
      email: resp.email,
      phone: resp.phone,
      address: resp.address,
      description: resp.description,
      landingPageHeroText: resp.landing_page_hero_text || '',
      landingPageHeroSubheading: resp.landing_page_hero_subheading || '',
      landingPageGradientStart: resp.landing_page_gradient_start || '#0f172a',
      landingPageGradientEnd: resp.landing_page_gradient_end || '#172033',
      waiver: resp.waiver,
      travelWaiver: resp.travel_waiver ? resp.travel_waiver: '',
      enrolEmails: resp.enrolment_emails.toString().split(',').join(', '),
      enrolment_emails: resp.enrolment_emails,
      logo: resp.logo + "?" + Math.floor((Math.random() * 1000) + 1),
      navbar_color: resp.navbar_color || '#5563b8',
      navbar_text_color: resp.navbar_text_color || '#ffffff',
      programTypeLabels: normalizedProgramTypeLabels,
      emailTemplates: normalizedEmailTemplates,
      merch: normalizedMerch,
      paymentCredentials: normalizedPaymentCredentials,
      venues,
      UDFs: resp.udfs ? resp.udfs: [],
      logoChanged: false,
      merchChanged: false,
    }, () => applyOrganizationTheme({
      navbar_color: resp.navbar_color || '#5563b8',
      navbar_text_color: resp.navbar_text_color || '#ffffff',
    }))
    this.programTypeLabelsDraft = normalizedProgramTypeLabels
    this.emailTemplatesDraft = normalizedEmailTemplates
    this.originalProfile = this.getProfileSnapshot({
      address: resp.address,
      description: resp.description,
      email: resp.email,
      enrolment_emails: resp.enrolment_emails,
      name: resp.name,
      phone: resp.phone,
      navbar_color: resp.navbar_color || '#5563b8',
      navbar_text_color: resp.navbar_text_color || '#ffffff',
      landingPageHeroText: resp.landing_page_hero_text || '',
      landingPageHeroSubheading: resp.landing_page_hero_subheading || '',
      landingPageGradientStart: resp.landing_page_gradient_start || '#0f172a',
      landingPageGradientEnd: resp.landing_page_gradient_end || '#172033',
      programTypeLabels: normalizedProgramTypeLabels,
      emailTemplates: normalizedEmailTemplates,
      merch: normalizedMerch,
      paymentCredentials: normalizedPaymentCredentials,
      venues,
      waiver: resp.waiver,
      travelWaiver: resp.travel_waiver ? resp.travel_waiver: '',
      UDFs: resp.udfs ? resp.udfs: []
    })
  }

  normalizeProgramTypeLabels = (labels = []) => {
    const defaultLabelsByBucket = getDefaultProgramTypeLabels().reduce((acc, entry) => {
      acc[entry.bucket] = entry
      return acc
    }, {})

    const normalized = labels.map((entry, index) => {
      const bucket = normalizeProgramTypeBucket(entry.bucket || entry.type || 'league')
      const defaultLabel = defaultLabelsByBucket[bucket]
      return {
        id: entry.id || makeUniqueKey(),
        label: entry.label || '',
        bucket,
        active: entry.active !== false,
        order: entry.order !== undefined ? entry.order : index,
        isDefault: entry.isDefault !== undefined ? entry.isDefault : (
          defaultLabel ? (entry.label || '').trim().toLowerCase() === defaultLabel.label.toLowerCase() : false
        ),
      }
    })

    getDefaultProgramTypeLabels().forEach((defaultEntry) => {
      const hasDefaultBucket = normalized.some((entry) => entry.isDefault && entry.bucket === defaultEntry.bucket)
      if (!hasDefaultBucket) {
        normalized.push({
          ...defaultEntry,
        })
      }
    })

    return normalized
  }

  getProfileSnapshot = (profile = null) => {
    const current = profile || {
      address: this.state.address,
      description: this.state.description,
      email: this.state.email,
      enrolment_emails: this.state.enrolment_emails,
      name: this.state.name,
      phone: this.state.phone,
      navbar_color: this.state.navbar_color,
      navbar_text_color: this.state.navbar_text_color,
      landingPageHeroText: this.state.landingPageHeroText,
      landingPageHeroSubheading: this.state.landingPageHeroSubheading,
      landingPageGradientStart: this.state.landingPageGradientStart,
      landingPageGradientEnd: this.state.landingPageGradientEnd,
      programTypeLabels: this.state.programTypeLabels,
      emailTemplates: this.state.emailTemplates,
      merch: this.state.merch,
      paymentCredentials: this.state.paymentCredentials,
      venues: this.state.venues,
      waiver: this.state.waiver,
      travelWaiver: this.state.travelWaiver,
      UDFs: this.state.UDFs,
    }
    return JSON.stringify(current)
  }

  hasPendingChanges = () => {
    if (!this.originalProfile) {
      return false
    }

    return this.state.logoChanged || this.state.merchChanged || this.getProfileSnapshot() !== this.originalProfile
  }

  handleTabSelect = (activeTab) => {
    if (!activeTab || activeTab === this.state.activeTab) {
      return
    }

    if (this.hasPendingChanges() || this.state.spinner) {
      alert('Please save your changes before switching tabs.')
      return
    }

    this.setState({ activeTab, confirm: false })
    const organizationId = this.state.organization_id
    if (organizationId) {
      localStorage.setItem(`organizationForm.activeTab.${organizationId}`, activeTab)
    }
  }

  handleVenueFieldChange = (field, value) => {
    this.setState({
      [field]: value,
      confirm: false,
    })
  }

  addVenue = async () => {
    this.setState({
      confirm: false,
    })

    const venueName = (this.state.venueName || '').trim()
    const streetAddress1 = (this.state.venueStreetAddress1 || '').trim()
    const streetAddress2 = (this.state.venueStreetAddress2 || '').trim()
    const city = (this.state.venueCity || '').trim()
    const region = (this.state.venueRegion || '').trim()
    const postalCode = (this.state.venuePostalCode || '').trim()
    const country = (this.state.venueCountry || '').trim()
    const addressParts = [streetAddress1, streetAddress2, city, region, postalCode, country].filter(Boolean)
    const venueAddress = addressParts.join(', ')
    if (!venueName) {
      alert('Please enter a venue name')
      return
    }

    if (!streetAddress1 || !city || !region || !postalCode || !country) {
      alert('Please fill out the address fields')
      return
    }

    const nextVenues = this.state.venues.slice()
    const venueRecord = {
      id: makeUniqueKey(),
      name: venueName,
      address: venueAddress,
      street_address_1: streetAddress1,
      street_address_2: streetAddress2,
      city,
      region,
      postal_code: postalCode,
      country,
    }

    const duplicate = nextVenues.find((venue) => {
      return (venue.name || '').trim().toLowerCase() === venueRecord.name.toLowerCase() ||
        (venue.address || '').trim().toLowerCase() === venueRecord.address.toLowerCase()
    })

    if (duplicate) {
      alert('That venue already exists')
      return
    }

    nextVenues.push(venueRecord)
    this.setState({
      venues: nextVenues,
      venueName: '',
      venueStreetAddress1: '',
      venueStreetAddress2: '',
      venueCity: '',
      venueRegion: '',
      venuePostalCode: '',
      venueCountry: 'Canada',
      confirm: false,
    }, () => this.saveVenues(nextVenues))
  }

  removeVenue = (index) => {
    const nextVenues = this.state.venues.slice()
    nextVenues.splice(index, 1)
    this.setState({
      venues: nextVenues,
      confirm: false,
    }, () => this.saveVenues(nextVenues))
  }

  saveVenues = (venues) => {
    if (!this.state.id || !this.state.token) {
      return
    }

    this.setState({ venues }, () => this.handleSubmit())
  }

  resetConfirmState = () => {
    if (this.confirmResetTimer) {
      clearTimeout(this.confirmResetTimer)
    }
    this.confirmResetTimer = setTimeout(() => {
      this.setState({ confirm: false })
    }, 3000)
  }

  readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result)
      };
      reader.onerror = function (error) {
        reject(error)
      };
    })
  }

  getFormFields = async () => {
    const logoInput = document.getElementById("logo")
    const logoFile = logoInput && logoInput.files ? logoInput.files[0] : undefined
    const programTypeLabels = this.programTypeLabelsDraft || this.state.programTypeLabels
    const emailTemplates = this.emailTemplatesDraft || this.state.emailTemplates
    const paymentCredentials = {
      ...createDefaultPaymentCredentials(),
      ...(this.state.paymentCredentials || {}),
    }
    let merch = this.state.merch.map((item) => ({
      name: item.name || '',
      logo: item.logo || '',
    }))

    if (logoFile) {
      const base64string = await this.readFileAsBase64(logoFile)
      const merchUploads = await Promise.all(
        merch.map(async (item, index) => {
          const merchInput = document.getElementById(`merch_logo_${index}`)
          const merchFile = merchInput && merchInput.files ? merchInput.files[0] : undefined
          if (merchFile) {
            return {
              ...item,
              logo: await this.readFileAsBase64(merchFile),
            }
          }
          return item
        })
      )

      return {
        "name": this.state.name,
        "email": this.state.email,
        "phone": this.state.phone,
        "address": this.state.address,
        "logo": base64string,
        "description": this.state.description,
        "landing_page_hero_text": this.state.landingPageHeroText,
        "landing_page_hero_subheading": this.state.landingPageHeroSubheading,
        "landing_page_gradient_start": this.state.landingPageGradientStart,
        "landing_page_gradient_end": this.state.landingPageGradientEnd,
        "waiver": this.state.waiver,
        "travel_waiver": this.state.travelWaiver,
        "enrolment_emails": this.state.enrolment_emails,
        "navbar_color": this.state.navbar_color,
        "navbar_text_color": this.state.navbar_text_color,
        "program_type_labels": programTypeLabels,
        "email_templates": emailTemplates,
        "udfs": this.state.UDFs,
        "merch": merchUploads,
        "payment_credentials": paymentCredentials,
        "venues": this.state.venues
      }
    }

    const merchUploads = await Promise.all(
      merch.map(async (item, index) => {
        const merchInput = document.getElementById(`merch_logo_${index}`)
        const merchFile = merchInput && merchInput.files ? merchInput.files[0] : undefined
        if (merchFile) {
          return {
            ...item,
            logo: await this.readFileAsBase64(merchFile),
          }
        }
        return item
      })
    )

    return {
      "name": this.state.name,
      "email": this.state.email,
      "phone": this.state.phone,
      "address": this.state.address,
      "description": this.state.description,
      "landing_page_hero_text": this.state.landingPageHeroText,
      "landing_page_hero_subheading": this.state.landingPageHeroSubheading,
      "landing_page_gradient_start": this.state.landingPageGradientStart,
      "landing_page_gradient_end": this.state.landingPageGradientEnd,
      "waiver": this.state.waiver,
      "travel_waiver": this.state.travelWaiver,
      "enrolment_emails": this.state.enrolment_emails,
      "navbar_color": this.state.navbar_color,
      "navbar_text_color": this.state.navbar_text_color,
      "program_type_labels": programTypeLabels,
      "email_templates": emailTemplates,
      "udfs": this.state.UDFs,
      "merch": merchUploads,
      "payment_credentials": paymentCredentials,
      "venues": this.state.venues
    }
  }

  loadPage = () => {
    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id
      },
      method: "GET",
      dataType: "json",
      url: this.state.endpoint,
    }).then(this.organizationsGetHandler)
  }


  handleSubmit = () => {
    this.setState({spinner: true})
    var rthis = this;
    this.getFormFields().then((formFields) => {
      console.log('handling org patch', formFields)
      $.ajax({
        headers: {
          "token": this.state.token
        },
        method: "PATCH",
        contentType: 'application/json',
        data: JSON.stringify({
          "id": this.state.id,
          "change": formFields
        }),
        url: this.state.endpoint,
        success: function (data) {
          if (data.errorMessage) {
            alert(data.errorMessage);
            rthis.setState({spinner: false})
          }
          else {
            rthis.setState({spinner: false, confirm: true, logoChanged: false, merchChanged: false})
            rthis.loadPage();
            rthis.resetConfirmState();
          }
        },
        error: function (err){
          rthis.setState({spinner: false})
          alert('Not authorized to update organization information')
        }
      })
    }).catch((error) => {
      console.log('error building organization form fields', error)
      this.setState({ spinner: false })
      alert('Unable to prepare organization data for saving')
    })
  }

  saveProgramTypes = () => {
    const programTypeLabels = this.programTypeLabelsDraft || this.state.programTypeLabels
    this.setState({ spinner: true })
    $.ajax({
      headers: {
        "token": this.state.token
      },
      method: "PATCH",
      contentType: 'application/json',
      data: JSON.stringify({
        "id": this.state.id,
        "change": {
          "program_type_labels": programTypeLabels
        }
      }),
      url: this.state.endpoint,
      success: () => {
        this.setState({ spinner: false, confirm: true, logoChanged: false })
        this.loadPage()
        this.resetConfirmState()
      },
      error: () => {
        this.setState({ spinner: false })
        alert('Not authorized to update organization information')
      }
    })
  }

  handleChange = (type, e) => {
    this.setState({[type]: e, confirm: false }, () => {
      if (type === 'navbar_color' || type === 'navbar_text_color') {
        applyOrganizationTheme({
          navbar_color: this.state.navbar_color,
          navbar_text_color: this.state.navbar_text_color,
        })
      }
    })
  }

  handleMerchChange = (index, field, value) => {
    const merch = this.state.merch.slice()
    if (!merch[index]) {
      return
    }

    merch[index] = {
      ...merch[index],
      [field]: value,
    }
    this.setState({
      merch,
      merchChanged: true,
      confirm: false,
    })
  }

  handlePaymentCredentialChange = (field, value) => {
    const paymentCredentials = {
      ...createDefaultPaymentCredentials(),
      ...(this.state.paymentCredentials || {}),
      [field]: value,
    }
    this.setState({
      paymentCredentials,
      confirm: false,
    })
  }

  handleLandingPageChange = (field, value) => {
    this.setState({
      [field]: value,
      confirm: false,
    })
  }

  getLandingPageUrl = () => {
    if (typeof window === 'undefined') {
      return ''
    }

    const organizationId = this.state.id || this.state.organization_id
    if (!organizationId) {
      return ''
    }

    return `${window.location.origin}/landing?organization_id=${organizationId}`
  }

  copyLandingPageUrl = () => {
    const url = this.getLandingPageUrl()
    if (!url) {
      return
    }

    if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
      return
    }

    window.prompt('Copy landing page URL', url)
  }

  normalizeBillingStatus = (transaction) => {
    const rawStatus = transaction && transaction.payment_gateway ? transaction.payment_gateway.status : null
    if (!rawStatus) {
      return null
    }

    if (typeof rawStatus === 'string') {
      return rawStatus
    }

    return rawStatus.status || null
  }

  loadBillingHistory = () => {
    const token = getParams().jwt || localStorage.getItem('jwt') || this.state.token || ''
    const organizationId = localStorage.getItem('organization_id') || this.state.organization_id || ''
    const billingUrl = (process.env.REACT_APP_END_POINT_BILLING_PRODUCTION || '').trim() || 'https://ye2kf3oatsh4nuvd55mxv32iqm0qvkpo.lambda-url.us-east-1.on.aws/'

    if (!token || !organizationId) {
      console.warn('billing history load skipped; missing token or organization_id', {
        hasToken: Boolean(token),
        hasOrganizationId: Boolean(organizationId),
      })
      this.setState({
        billingHistory: [],
        billingLoading: false,
      })
      return
    }

    if (token !== this.state.token || organizationId !== this.state.organization_id) {
      this.setState({
        token,
        organization_id: organizationId,
      })
    }

    this.setState({ billingLoading: true })
    $.ajax({
      headers: {
        "token": token,
        "organization_id": organizationId,
      },
      method: "GET",
      dataType: "json",
      url: billingUrl,
    }).then((resp) => {
      const billingHistory = Array.isArray(resp)
        ? resp
        : Array.isArray(resp && resp.message)
          ? resp.message
          : []
      this.setState({ billingHistory, billingLoading: false })
    }).catch((error) => {
      console.error('billing history load failed', error)
      this.setState({
        billingHistory: [],
        billingLoading: false,
      })
    })
  }

  handleCreateInvoice = (billingRow) => {
    window.alert(`Create invoice for ${billingRow.dateLabel} is not wired yet.`)
  }

  uploadMerchLogo = (index) => {
    const merchInput = document.getElementById(`merch_logo_${index}`)
    const merchFile = merchInput && merchInput.files ? merchInput.files[0] : undefined
    if (merchFile && merchFile.size > 2097152) {
      alert("The image size should be smaller than 2MB!")
      merchInput.value = ""
      return
    }

    if (merchFile) {
      this.setState({ merchChanged: true, confirm: false })
    }
  }

  handleProgramTypeChange = (field, value) => {
    this.setState({
      [field]: value,
      confirm: false,
    })
  }

  addProgramTypeLabel = () => {
    const label = (this.state.programTypeLabel || '').trim()
    const bucket = this.state.programTypeBucket

    if (!label) {
      alert('Please enter a program type label')
      return
    }

    if (!bucket) {
      alert('Please choose a reporting bucket')
      return
    }

    const duplicate = this.state.programTypeLabels.find((entry) => {
      return (entry.label || '').trim().toLowerCase() === label.toLowerCase()
    })

    if (duplicate) {
      alert('That label already exists for this organization')
      return
    }

    const nextProgramTypeLabels = this.state.programTypeLabels.slice()
    nextProgramTypeLabels.push({
      id: makeUniqueKey(),
      label,
      bucket,
      active: true,
      isDefault: false,
    })

    this.programTypeLabelsDraft = nextProgramTypeLabels
    this.setState({
      programTypeLabels: nextProgramTypeLabels,
      programTypeLabel: '',
      programTypeBucket: 'league',
      addProgramType: false,
      confirm: false,
    })
  }

  updateProgramTypeLabel = (index, field, value) => {
    const nextProgramTypeLabels = this.state.programTypeLabels.slice()
    if (!nextProgramTypeLabels[index]) {
      return
    }

    nextProgramTypeLabels[index] = {
      ...nextProgramTypeLabels[index],
      [field]: field === 'bucket' ? normalizeProgramTypeBucket(value) : value,
    }
    this.programTypeLabelsDraft = nextProgramTypeLabels
    this.setState({
      programTypeLabels: nextProgramTypeLabels,
      confirm: false,
    })
  }

  removeProgramTypeLabel = (index) => {
    const nextProgramTypeLabels = this.state.programTypeLabels.slice()
    nextProgramTypeLabels.splice(index, 1)
    this.programTypeLabelsDraft = nextProgramTypeLabels
    this.setState({ programTypeLabels: nextProgramTypeLabels, confirm: false })
  }

  startProgramTypeAdd = () => {
    this.setState({
      addProgramType: true,
      programTypeLabel: '',
      programTypeBucket: 'league',
      confirm: false,
    })
  }

  cancelProgramTypeEdit = () => {
    this.setState({
      addProgramType: false,
      programTypeLabel: '',
      programTypeBucket: 'league',
      confirm: false,
    })
  }

  getEmailTemplateList = () => {
    const defaults = getDefaultEmailTemplates()
    return Object.keys(defaults).map((key) => ({
      ...defaults[key],
      ...(this.state.emailTemplates[key] || {}),
    }))
  }

  getSelectedEmailTemplate = () => {
    const templates = this.state.emailTemplates || {}
    const selectedKey = this.state.selectedEmailTemplateKey || 'parent_registration_confirmation'
    return templates[selectedKey] || getDefaultEmailTemplates()[selectedKey]
  }

  handleEmailTemplateSelect = (selectedEmailTemplateKey) => {
    this.setState({
      selectedEmailTemplateKey,
      confirm: false,
    })
  }

  updateEmailTemplate = (key, field, value) => {
    const nextEmailTemplates = { ...(this.state.emailTemplates || {}) }
    const existing = nextEmailTemplates[key] || getDefaultEmailTemplates()[key]
    nextEmailTemplates[key] = {
      ...existing,
      [field]: value,
    }
    this.emailTemplatesDraft = nextEmailTemplates
    this.setState({
      emailTemplates: nextEmailTemplates,
      confirm: false,
    })
  }

  uploadLogo = () => {
    const logoInput = document.getElementById("logo")
    const logoFile = logoInput && logoInput.files ? logoInput.files[0] : undefined
    if(logoFile && logoFile.size > 2097152){
      alert("The image size should be smaller than 2MB!");
      logoInput.value = "";
    } else if (logoFile) {
      this.setState({ logoChanged: true, confirm: false })
    }
  }

  handleEnrolmentEmailChange = (emails) => {
    var trimmed = []
    var allEmails = emails.target.value.split(',')
    allEmails.forEach(email => {
      var trim = email.trim()
      trimmed.push(trim)
    })
    this.setState({ 
      enrolEmails: emails.target.value,
      enrolment_emails: trimmed,
      confirm: false
     })
  }

  acceptUDF = () => {
    var tempUDFs = this.state.UDFs;
    var UDF_Label = document.getElementById("UDF_Label").value
    var UDF_type = document.getElementById("UDF_type").value
    var UDF_required = JSON.parse(document.getElementById("UDF_required").value) // to capture Boolean value
    var UDF_values = document.getElementById("UDF_values") ? document.getElementById("UDF_values").value : ""

    if (UDF_type === "list") {
      var trimmedList = []
      var trimList = UDF_values.split(',')
      trimList.forEach(val => {
        var trim = val.trim()
        trimmedList.push(trim)
      })
    }
    
    if ( UDF_Label === "" ||  UDF_type === "" ||  UDF_required === "" || UDF_values === "" && UDF_type === "list") {
      alert("Please enter all the fields in UDF")

    } else if (this.state.UDFs.length >= 30) {
      alert("You are only allowed 30 UDFS. Please email support@hoopstir.com to request a UDF deletion or alteration.")
    } else {
      var findFreeKey = () => {
        for(let index = 1; index < 31; index++) {
          if(this.state.UDFs.findIndex(u => u.key == index) === -1) {
            return index;
          }
        }
      }
      tempUDFs.push({
        key: findFreeKey(),//this.state.UDFs.length + 1,
        label: UDF_Label,
        type: {
          format: UDF_type,
          values: UDF_type !== "list" ? UDF_values : trimmedList
        },
        required: UDF_required,
      });
      this.setState({ addUDF: false, UDFs: tempUDFs, udfType: "", confirm: false });
    }
  }

  renderUDFs = () => {
    var addControl = null;
    if (this.state.addUDF) {
      addControl = 
      <Row className="form-group">
        <Col sm={3}>
          <ControlLabel>Label</ControlLabel>
          <FormControl className="opaque-grey" type="text" id="UDF_Label"/>
        </Col>
        <Col sm={3}>
          <ControlLabel>Required</ControlLabel>
          <FormControl className="opaque-grey" componentClass="select" id="UDF_required" placeholder="Required">
            <option value="" disabled selected>Please Select</option>
            <option value={true}>Yes</option>
            <option value={false}>No</option>
          </FormControl>
        </Col >
        <Col sm={3}>
          <ControlLabel>Type</ControlLabel>
          <FormControl className="opaque-grey" componentClass="select" id="UDF_type" onChange={(e) => this.setState({udfType: e.target.value})}>
            <option value="" disabled selected>Please Select</option>
            <option value="list">List</option>
            <option value="text">Text</option>
            <option value="number">Number</option>
          </FormControl>
        </Col>
        {
          this.state.udfType === "list" ?
          <Col sm={3}>
            <ControlLabel style={{width: '100%'}}>List Values (separate by comma)</ControlLabel>
            <div className="form-group-options">
            <InputGroup className="col-sm-12">
              <FormControl className="opaque-grey" type="text" id="UDF_values"/>
              <InputGroup.Button>
                <Button style={{marginBottom: '6%'}} className="orange-outline" onClick={this.acceptUDF}>Accept</Button>
              </InputGroup.Button>
            </InputGroup>
            <a className="cancel-x" onClick={() => this.setState({ addUDF: false })}><FontAwesomeIcon icon={faTimes} size="1x" color='white' /></a>
            </div>
          </Col>
          :
          <Col lg={3} sm={3}>
            <Row>
            <Col lg={2} sm={2} xs={6} style={{marginTop: "25px"}}>
                <Button className="planfeaturebtn" onClick={this.acceptUDF}>Accept</Button>
            </Col>  
              
            <Col lg={2} sm={2} xs={5} style={{marginTop: "25px", marginLeft: "75px" }}>   
              <Button className="deleterow" onClick={() => this.setState({ addUDF: false })}>cancel</Button>
            </Col>
            </Row>
          </Col>

          
        }
      </Row>
    } else {
      addControl =
      <Row>
        <Col lg={3} sm={4}>
          <Button className="add-session-btn" onClick={() => this.setState({ addUDF: !this.state.addUDF })}>Add Custom Field</Button>
        </Col>
      </Row>
    }

    return (
      this.state.UDFs.length !== 0 ? (
        <div>
          <Row>
            <ControlLabel className="col-sm-3">Label</ControlLabel>
            <ControlLabel className="col-sm-3">Required</ControlLabel>
            <ControlLabel className="col-sm-3">Type&nbsp;
              <a className="heading-hint" onClick={() => this.setState({ udfTypeHint: !this.state.udfTypeHint })}>
                <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                { 
                  this.state.udfTypeHint ?
                  <div className="hint-tip-text" id="payment-hint">
                    <span style={{whiteSpace: 'pre-wrap'}}>{`List - Lists display as a dropdown field.\nText - Text fields collect text, numbers and special characters.\nNumbers - Number fields can only collect numbers, dashes and decimals.`}</span>
                  </div>
                  : ''
                }
              </a></ControlLabel>
            <ControlLabel className="col-sm-3">Value</ControlLabel>
          </Row>
            { this.state.UDFs.map((input, index) => {
              return (
                <Row key={makeUniqueKey()} className="form-group">
                  <Col sm={3}>
                    <FormControl disabled value={input.label} className="col-sm-4 opaque-grey" type="text"/>
                  </Col>
                  <Col sm={3}>
                    <FormControl disabled value={input.required === true ? "Yes" : "No"} className="col-sm-2 opaque-grey" type="text"/>
                  </Col>
                  <Col sm={3}>
                    <FormControl disabled value={input.type.format} className="col-sm-2 opaque-grey" type="text"/>
                  </Col>
                    {
                    input.type.format === "list" ?
                    <Col sm={3}>
                      <InputGroup className="col-sm-12">
                        <FormControl className="opaque-grey" type="text" value={input.type.values}/>
                        <InputGroup.Button>
                        <Button className="button2" value={index} onClick={() => this.editOption(input)}>Edit</Button>
                        </InputGroup.Button>
                      </InputGroup>
                    </Col>
                    :
                    <Col sm={3}>
                      <Button className="button2" value={index} onClick={() => this.editOption(input)}>Edit</Button>
                    </Col>
                  }
                  {/* {
                    input.type.format === "list" ?
                    <Col sm={3}>
                      <InputGroup className="col-sm-12">
                        <FormControl className="opaque-grey" type="text" value={input.type.values}/>
                        <InputGroup.Button>
                        <Button className="orange-outline" value={index} onClick={(e) => this.removeOption(e.target.value)}>Delete</Button>
                        </InputGroup.Button>
                      </InputGroup>
                    </Col>
                    :
                    <Col sm={3}>
                      <Button className="orange-outline" value={index} onClick={(e) => this.removeOption(e.target.value)}>Delete</Button>
                    </Col>
                  } */}
                </Row>)
            })}
            {addControl}
        </div>
      ):addControl
    )
  }

  editOption = (e) => {
    if (window.confirm("Please email support@hoopstir.com to request a UDF edit or removal")) {
      console.log('UDF to edit/remove', e)
    }
  }
  removeOption = (e) => {
    if (window.confirm("If you delete this field your enrolment forms will no longer collect this information.  Are you sure you want to delete this field?")) {
      var temp = this.state.UDFs
      temp.splice(e, 1)
      this.setState({ UDFs: temp, confirm: false })
    }
  }

  renderSaveButton = (buttonClassName, label) => {
    const disabled = !this.hasPendingChanges() || this.state.spinner
    return (
      <Button
        type="button"
        className={buttonClassName}
        onClick={(e) => {
          e.preventDefault()
          this.handleSubmit()
        }}
        disabled={disabled}
      >
        {label}
      </Button>
    )
  }

  renderBusinessDetails = () => (
    <form className="padded">
        <Row>
        <Col sm={6}>
          <Row>
            <Col sm={6}>
                <FormGroup>
                  <ControlLabel>Organization Name</ControlLabel>
                  <FormControl 
                    className="opaque-grey"
                    name="organization_name"
                    type="text"
                    id="organization_name"
                    value={this.state.name}
                    onChange={(e) => this.handleChange('name', e.target.value)}
                    />
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <ControlLabel>Organization Contact Phone</ControlLabel>
                  <FormControl
                    className="opaque-grey"
                    type="text"
                    name="phone"
                    id="phone"
                    value={this.state.phone}
                    onChange={(e) => this.handleChange('phone', e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <FormGroup>
                  <ControlLabel>Origin Email</ControlLabel>
                  <FormControl 
                    disabled className="opaque-grey"
                    name="email"
                    type="text"
                    id="email"
                    value={this.state.email}
                  />
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <ControlLabel>Enrolment Notifications </ControlLabel>
                  <FormControl 
                    className="opaque-grey"
                    name="enrolment_emails"
                    type="text"
                    id="enrolment_emails"
                    value={this.state.enrolEmails} onChange={this.handleEnrolmentEmailChange}
                  />
                </FormGroup>
              </Col>
          </Row>
          </Col>

          <Col sm={6}>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Address</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  componentClass="textarea"
                  rows={3}
                  type="text"
                  id="address"
                  value={this.state.address}
                  onChange={(e) => this.handleChange('address', e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Organization Description</ControlLabel>
                <FormControl 
                  className="opaque-grey"
                  id="description"
                  rows={3}
                  componentClass="textarea"
                  value={this.state.description} onChange={(e) => this.handleChange('description', e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          </Col>

          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Logo</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  id="logo"
                  type="file"
                  onChange={this.uploadLogo}
                />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <ControlLabel>Primary Background Color</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  type="color"
                  id="navbar_color"
                  value={this.state.navbar_color}
                  onChange={(e) => this.handleChange('navbar_color', e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <ControlLabel>Primary Text Color</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  type="color"
                  id="navbar_text_color"
                  value={this.state.navbar_text_color}
                  onChange={(e) => this.handleChange('navbar_text_color', e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Image
                key={this.state.logo}
                src={this.state.logo}
                className="logo-img" />
            </Col>
          </Row>
          <Row style={{marginTop: "20px" }}>
            {
              this.state.spinner ? 
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
               :
              this.state.confirm ?
                <Col sm={3} className="pull-right">
                  <div className="email-sent pull-right" style={{display: 'flex'}}>
                    <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                    <p className="" style={{verticalAlign: "super"}}>Profile Updated</p>
                  </div>
                </Col>
                :
                <Fragment>
                  <Col sm={3} className="pull-right">
                    {this.renderSaveButton('modalbutton', 'Save Changes')}
                  </Col>
                </Fragment>
            }
        </Row>                      
    </form>
  )

  renderMerchandise = () => (
    <form className="padded">
      <Row>
        <Col sm={12}>
          <h3>Merchandise</h3>
          <p>Define up to three merch items. These names and logos are used in pricing and enrolment.</p>
        </Col>
      </Row>
      {this.state.merch.map((item, index) => (
        <Row key={`merch-slot-${index}`} style={{ marginBottom: '20px' }}>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Item Name</ControlLabel>
              <FormControl
                className="opaque-grey"
                type="text"
                value={item.name}
                onChange={(e) => this.handleMerchChange(index, 'name', e.target.value)}
                placeholder={`Merch item ${index + 1}`}
              />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup>
              <ControlLabel>Logo</ControlLabel>
              <FormControl
                className="opaque-grey"
                id={`merch_logo_${index}`}
                type="file"
                onChange={() => this.uploadMerchLogo(index)}
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Current Preview</ControlLabel>
              <div>
                {item.logo ? (
                  <Image
                    src={item.logo}
                    style={{ maxHeight: '60px', maxWidth: '100%', objectFit: 'contain' }}
                  />
                ) : (
                  <div style={{ color: '#9aa0a6', paddingTop: '10px' }}>No logo selected</div>
                )}
              </div>
            </FormGroup>
          </Col>
        </Row>
      ))}
      <Row style={{ marginTop: '20px' }}>
        {
          this.state.spinner ? 
          <Col sm={3} className="pull-right">
            <div className="enrolment-loader pull-right"></div>
          </Col>
           :
          this.state.confirm ?
            <Col sm={3} className="pull-right">
              <div className="email-sent pull-right" style={{display: 'flex'}}>
                <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                <p className="" style={{verticalAlign: "super"}}>Profile Updated</p>
              </div>
            </Col>
            :
            <Fragment>
              <Col sm={3} className="pull-right">
                {this.renderSaveButton('modalbutton', 'Save Changes')}
              </Col>
            </Fragment>
        }
      </Row>
    </form>
  )

  renderIntegrations = () => {
    const paymentCredentials = this.state.paymentCredentials || createDefaultPaymentCredentials()
    const gateway = paymentCredentials.gateway || 'converge'
    const isStripe = gateway === 'stripe'

    return (
      <form className="padded">
        <Row>
          <Col sm={12}>
            <div className="integration-panel">
              <div className="integration-panel-header">
                <div>
                  <h3 style={{ margin: 0 }}>Integrations</h3>
                  <p className="integration-panel-subtitle">
                    Manage the payment credentials used by enrolment, checkout, and refunds.
                  </p>
                </div>
              </div>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <ControlLabel>Payment Gateway</ControlLabel>
                    <FormControl
                      className="opaque-grey"
                      componentClass="select"
                      value={gateway}
                      onChange={(e) => this.handlePaymentCredentialChange('gateway', e.target.value)}
                    >
                      <option value="converge">Converge</option>
                      <option value="stripe">Stripe</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <div className="integration-hint">
                    Switching gateways changes the credential fields below, but preserves whatever you have already entered.
                  </div>
                </Col>
              </Row>

              {isStripe ? (
                <Row>
                  <Col sm={6}>
                    <FormGroup>
                      <ControlLabel>Stripe Account ID</ControlLabel>
                      <FormControl
                        className="opaque-grey"
                        type="text"
                        value={paymentCredentials.account || ''}
                        onChange={(e) => this.handlePaymentCredentialChange('account', e.target.value)}
                        placeholder="acct_..."
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={3}>
                    <FormGroup>
                      <ControlLabel>Currency</ControlLabel>
                      <FormControl
                        className="opaque-grey"
                        componentClass="select"
                        value={paymentCredentials.currency_type || 'CAD'}
                        onChange={(e) => this.handlePaymentCredentialChange('currency_type', e.target.value)}
                      >
                        <option value="CAD">CAD</option>
                        <option value="USD">USD</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col sm={4}>
                    <FormGroup>
                      <ControlLabel>Merchant ID</ControlLabel>
                      <FormControl
                        className="opaque-grey"
                        type="text"
                        value={paymentCredentials.ssl_merchant_id || ''}
                        onChange={(e) => this.handlePaymentCredentialChange('ssl_merchant_id', e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={4}>
                    <FormGroup>
                      <ControlLabel>User ID</ControlLabel>
                      <FormControl
                        className="opaque-grey"
                        type="text"
                        value={paymentCredentials.ssl_user_id || ''}
                        onChange={(e) => this.handlePaymentCredentialChange('ssl_user_id', e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={4}>
                    <FormGroup>
                      <ControlLabel>PIN</ControlLabel>
                      <FormControl
                        className="opaque-grey"
                        type="password"
                        value={paymentCredentials.ssl_pin || ''}
                        onChange={(e) => this.handlePaymentCredentialChange('ssl_pin', e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Row>
        <Row style={{ marginTop: '20px' }}>
          {
            this.state.spinner ?
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
            :
            this.state.confirm ?
              <Col sm={3} className="pull-right">
                <div className="email-sent pull-right" style={{display: 'flex'}}>
                  <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                  <p className="email-text" style={{verticalAlign: "super"}}>Profile Updated</p>
                </div>
              </Col>
            :
              <Fragment>
                <Col sm={3} className="pull-right">
                  {this.renderSaveButton('button2', 'Save Changes')}
                </Col>
              </Fragment>
          }
        </Row>
      </form>
    )
  }

  renderBilling = () => {
    const { billingHistory, billingLoading } = this.state

    return (
      <div className="padded">
        <div className="integration-panel">
          <div className="integration-panel-header">
            <div>
              <h3 style={{ margin: 0 }}>Billing</h3>
              <p className="integration-panel-subtitle">
                View monthly enrolment history.
              </p>
            </div>
          </div>

          {billingLoading ? (
            <div className="integration-hint">Loading monthly enrolment history...</div>
          ) : billingHistory.length === 0 ? (
            <div className="integration-hint">No monthly enrolment history is available yet.</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover" style={{ marginBottom: 0 }}>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Document Name</th>
                    <th>Total Registrations</th>
                  </tr>
                </thead>
                <tbody>
                  {billingHistory.map((row) => (
                    <tr key={row.key}>
                      <td>{row.dateLabel || row.month_label || ''}</td>
                      <td>{row.documentName || row.document_name || 'Registration Summary'}</td>
                      <td>{row.totalRegistrations !== undefined ? row.totalRegistrations : (row.total_registrations || 0)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )
  }

  renderLandingPage = () => {
    const landingPageUrl = this.getLandingPageUrl()
    const heroText = this.state.landingPageHeroText || this.state.name || 'Welcome to Hoopstir'
    const heroSubheading = this.state.landingPageHeroSubheading || 'Use this public landing page to introduce your club and guide visitors into the login flow.'
    const loginUrl = landingPageUrl
      ? `${window.location.origin}/login?organization_id=${this.state.id || this.state.organization_id}`
      : '#'

    return (
      <form className="padded">
        <div className="integration-panel landing-page-panel">
          <div className="integration-panel-header landing-page-panel-header">
            <div>
              <h3 style={{ margin: 0 }}>Landing Page</h3>
              <p className="integration-panel-subtitle">
                Edit the public hero copy that appears before visitors reach the login page.
              </p>
            </div>
            <div className="landing-page-link-card">
              <div className="landing-page-link-label">Public link</div>
              <div className="landing-page-link-row">
                <FormControl
                  className="opaque-grey landing-page-link-input"
                  type="text"
                  readOnly
                  value={landingPageUrl}
                />
                <Button type="button" className="button2" onClick={this.copyLandingPageUrl} disabled={!landingPageUrl}>
                  Copy Link
                </Button>
              </div>
            </div>
          </div>

          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Gradient Start</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  type="color"
                  value={this.state.landingPageGradientStart}
                  onChange={(e) => this.handleLandingPageChange('landingPageGradientStart', e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Gradient End</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  type="color"
                  value={this.state.landingPageGradientEnd}
                  onChange={(e) => this.handleLandingPageChange('landingPageGradientEnd', e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Gradient Start</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  type="color"
                  value={this.state.landingPageGradientStart}
                  onChange={(e) => this.handleLandingPageChange('landingPageGradientStart', e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Gradient End</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  type="color"
                  value={this.state.landingPageGradientEnd}
                  onChange={(e) => this.handleLandingPageChange('landingPageGradientEnd', e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Hero Text</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  type="text"
                  value={this.state.landingPageHeroText}
                  onChange={(e) => this.handleLandingPageChange('landingPageHeroText', e.target.value)}
                  placeholder={this.state.name || 'Your club headline'}
                />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <ControlLabel>Hero Subheading</ControlLabel>
                <FormControl
                  className="opaque-grey"
                  componentClass="textarea"
                  rows={4}
                  value={this.state.landingPageHeroSubheading}
                  onChange={(e) => this.handleLandingPageChange('landingPageHeroSubheading', e.target.value)}
                  placeholder="A short line that explains what visitors can do next."
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div className="landing-page-preview">
                <div className="landing-page-preview-topline">
                  <div className="landing-page-preview-kicker">Public landing page preview</div>
                  <div className="landing-page-preview-caption">
                    This is the first thing a visitor sees before they continue to login.
                  </div>
                </div>
                <div className="landing-page-preview-grid">
                  <div className="landing-page-preview-copy">
                    <h2>{heroText}</h2>
                    <p>{heroSubheading}</p>
                    <div className="landing-page-preview-actions">
                      <Button
                        type="button"
                        className="modalbutton"
                        onClick={() => window.open(loginUrl, '_blank', 'noopener,noreferrer')}
                        disabled={!loginUrl || loginUrl === '#'}
                      >
                        Open Login Flow
                      </Button>
                      <div className="landing-page-preview-note">
                        The login page keeps the org context using the same organization id.
                      </div>
                    </div>
                  </div>
                  <div className="landing-page-preview-card">
                    <div className="landing-page-preview-card-label">Brand preview</div>
                    <div className="landing-page-preview-logo-slot">
                      {this.state.logo ? (
                        <Image src={this.state.logo} className="landing-page-preview-logo" />
                      ) : (
                        <div className="landing-page-preview-logo-empty">No logo uploaded yet</div>
                      )}
                    </div>
                    <div className="landing-page-preview-org">{this.state.name || 'Organization name'}</div>
                    <div className="landing-page-preview-link">{landingPageUrl || 'Save to generate the public link.'}</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <Row style={{ marginTop: '20px' }}>
          {
            this.state.spinner ?
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
            :
            this.state.confirm ?
              <Col sm={3} className="pull-right">
                <div className="email-sent pull-right" style={{display: 'flex'}}>
                  <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                  <p className="email-text" style={{verticalAlign: "super"}}>Profile Updated</p>
                </div>
              </Col>
            :
              <Fragment>
                <Col sm={3} className="pull-right">
                  {this.renderSaveButton('button2', 'Save Changes')}
                </Col>
              </Fragment>
          }
        </Row>
      </form>
    )
  }

  renderWaivers = () => (
    <form className="padded">
        <Row>
          <Col sm={12}>
            <FormGroup>
              <ControlLabel>Enrolment Waiver</ControlLabel>
              <FormControl
                className="opaque-grey"
                id="enrol_waiver"
                rows={6}
                componentClass="textarea"
                value={this.state.waiver}
                onChange={(e) => this.handleChange('waiver', e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <FormGroup>
              <ControlLabel>Travel Waiver</ControlLabel>
              <FormControl
                className="opaque-grey"
                id="travel_waiver"
                componentClass="textarea"
                value={this.state.travelWaiver} onChange={(e) => this.handleChange('travelWaiver', e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row style={{marginTop: "20px" }}>
            {
              this.state.spinner ? 
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
               :
              this.state.confirm ?
                <Col sm={3} className="pull-right">
                  <div className="email-sent pull-right" style={{display: 'flex'}}>
                    <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                    <p className="email-text" style={{verticalAlign: "super"}}>Profile Updated</p>
                  </div>
                </Col>
                :
                <Fragment>
                  <Col sm={3} className="pull-right">
                    {this.renderSaveButton('button2', 'Save Changes')}
                  </Col>
                </Fragment>
            }
        </Row>                     
    </form>
  )

  renderCustomFields = () => (
    <form className="padded">

        <Row>
          <Col sm={12}>
            <FormGroup>
              {this.renderUDFs()}
            </FormGroup>
          </Col>
        </Row>


        <Row style={{marginTop: "20px" }}>
            {
              this.state.spinner ? 
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
               :
              this.state.confirm ?
                <Col sm={3} className="pull-right">
                  <div className="email-sent pull-right" style={{display: 'flex'}}>
                    <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                    <p className="email-text" style={{verticalAlign: "super"}}>Profile Updated</p>
                  </div>
                </Col>
                :
                <Fragment>
                  <Col sm={3} className="pull-right">
                    {this.renderSaveButton('button2', 'Save Changes')}
                  </Col>
                </Fragment>
            }
        </Row>
    </form>
  )

  renderProgramTypes = () => {
    const { addProgramType, programTypeLabel, programTypeBucket, programTypeLabels } = this.state

    const addControl = addProgramType ? (
      <Row className="form-group">
        <Col sm={4}>
          <ControlLabel>Label</ControlLabel>
          <FormControl
            className="opaque-grey"
            type="text"
            value={programTypeLabel}
            onChange={(e) => this.handleProgramTypeChange('programTypeLabel', e.target.value)}
          />
        </Col>
        <Col sm={4}>
          <ControlLabel>Reporting Bucket</ControlLabel>
          <FormControl
            className="opaque-grey"
            componentClass="select"
            value={programTypeBucket}
            onChange={(e) => this.handleProgramTypeChange('programTypeBucket', e.target.value)}
          >
            {PROGRAM_TYPE_BUCKETS.map((bucket) => (
              <option key={bucket} value={bucket}>
                {getProgramTypeBucketLabel(bucket)}
              </option>
            ))}
          </FormControl>
        </Col>
        <Col sm={4} style={{ marginTop: '25px' }}>
          <Button type="button" className="planfeaturebtn" onClick={this.addProgramTypeLabel}>Accept</Button>
          <Button type="button" className="deleterow" style={{ marginLeft: '12px' }} onClick={this.cancelProgramTypeEdit}>Cancel</Button>
        </Col>
      </Row>
    ) : (
      <Row>
        <Col lg={3} sm={4}>
          <Button type="button" className="add-session-btn" onClick={this.startProgramTypeAdd}>Add Program Type</Button>
        </Col>
      </Row>
    )

    return (
      <form className="padded">
        <div style={{ marginBottom: '12px', color: '#222', fontSize: '0.95rem' }}>
          Edit the label or bucket directly in the fields below. Default program types are shown here by default.
        </div>
        {programTypeLabels.length > 0 ? (
          <div>
            <Row>
              <ControlLabel className="col-sm-4">Label</ControlLabel>
              <ControlLabel className="col-sm-4">Reporting Bucket</ControlLabel>
            </Row>
            {programTypeLabels.map((input, index) => (
              <Row key={input.id || `${input.label}-${index}`} className="form-group" style={{ alignItems: 'center' }}>
                <Col sm={4}>
                  <FormControl
                    value={input.label}
                    className="opaque-grey"
                    type="text"
                    style={{
                      backgroundColor: '#f7f8ff',
                      borderColor: 'rgba(85, 99, 184, 0.35)',
                      boxShadow: input.isDefault ? '0 0 0 1px rgba(85, 99, 184, 0.15)' : 'none',
                    }}
                    onChange={(e) => this.updateProgramTypeLabel(index, 'label', e.target.value)}
                  />
                </Col>
                <Col sm={4}>
                  <FormControl
                    componentClass="select"
                    value={input.bucket}
                    className="opaque-grey"
                    style={{
                      backgroundColor: '#f7f8ff',
                      borderColor: 'rgba(85, 99, 184, 0.35)',
                      boxShadow: input.isDefault ? '0 0 0 1px rgba(85, 99, 184, 0.15)' : 'none',
                    }}
                    onChange={(e) => this.updateProgramTypeLabel(index, 'bucket', e.target.value)}
                  >
                    {PROGRAM_TYPE_BUCKETS.map((bucket) => (
                      <option key={bucket} value={bucket}>
                        {getProgramTypeBucketLabel(bucket)}
                      </option>
                    ))}
                  </FormControl>
                </Col>
                <Col sm={4} style={{ marginTop: '5px' }}>
                  {!input.isDefault && (
                    <Button type="button" className="deleterow" onClick={() => this.removeProgramTypeLabel(index)}>Delete</Button>
                  )}
                </Col>
              </Row>
            ))}
            {addControl}
          </div>
        ) : (
          addControl
        )}
        <Row style={{ marginTop: '20px' }}>
          {
            this.state.spinner ?
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
            :
            this.state.confirm ?
              <Col sm={3} className="pull-right">
                <div className="email-sent pull-right" style={{display: 'flex'}}>
                  <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                  <p className="email-text" style={{verticalAlign: "super"}}>Profile Updated</p>
                </div>
              </Col>
            :
              <Fragment>
                <Col sm={3} className="pull-right">
                  <Button
                    type="button"
                    className="button2"
                    onClick={(e) => {
                      e.preventDefault()
                      this.saveProgramTypes()
                    }}
                    disabled={!this.hasPendingChanges() || this.state.spinner || this.state.addProgramType}
                  >
                    Save Changes
                  </Button>
                </Col>
              </Fragment>
          }
        </Row>
      </form>
    )
  }

  renderVenues = () => {
    const { venues, venueName, venueStreetAddress1, venueStreetAddress2, venueCity, venueRegion, venuePostalCode, venueCountry } = this.state

    return (
      <form className="padded">
        <Row>
          <Col sm={12}>
            <h3>Venues</h3>
            <p>Create a venue with the address details you want to save and reuse later when adding program sessions.</p>
          </Col>
        </Row>

        <Row>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Venue Name</ControlLabel>
              <FormControl
                className="opaque-grey"
                type="text"
                value={venueName}
                onChange={(e) => this.handleVenueFieldChange('venueName', e.target.value)}
                placeholder="Enter a friendly name"
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Street Address</ControlLabel>
              <FormControl
                className="opaque-grey"
                componentClass="textarea"
                rows={2}
                value={venueStreetAddress1}
                onChange={(e) => this.handleVenueFieldChange('venueStreetAddress1', e.target.value)}
                placeholder="Street number and name"
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Address Line 2</ControlLabel>
              <FormControl
                className="opaque-grey"
                type="text"
                value={venueStreetAddress2}
                onChange={(e) => this.handleVenueFieldChange('venueStreetAddress2', e.target.value)}
                placeholder="Suite, unit, or landmark"
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>City</ControlLabel>
              <FormControl
                className="opaque-grey"
                type="text"
                value={venueCity}
                onChange={(e) => this.handleVenueFieldChange('venueCity', e.target.value)}
                placeholder="City"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>State / Province</ControlLabel>
              <FormControl
                className="opaque-grey"
                type="text"
                value={venueRegion}
                onChange={(e) => this.handleVenueFieldChange('venueRegion', e.target.value)}
                placeholder="BC"
              />
            </FormGroup>
          </Col>
          <Col sm={3}>
            <FormGroup>
              <ControlLabel>Postal / Zip</ControlLabel>
              <FormControl
                className="opaque-grey"
                type="text"
                value={venuePostalCode}
                onChange={(e) => this.handleVenueFieldChange('venuePostalCode', e.target.value)}
                placeholder="V4N 1E3"
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <ControlLabel>Country</ControlLabel>
              <FormControl
                className="opaque-grey"
                type="text"
                value={venueCountry}
                onChange={(e) => this.handleVenueFieldChange('venueCountry', e.target.value)}
                placeholder="Canada"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <FormGroup>
              <ControlLabel>Preview</ControlLabel>
              <div className="venues-selected-address">
                <div className="venues-selected-address-label">Saved address</div>
                <div className="venues-selected-address-value">
                  {[venueStreetAddress1, venueStreetAddress2, venueCity, venueRegion, venuePostalCode, venueCountry].filter(Boolean).join(', ') || 'Fill out the form to preview the saved address.'}
                </div>
              </div>
            </FormGroup>
            <Button type="button" className="button2 venues-add-button" onClick={this.addVenue} disabled={!venueName.trim() || !venueStreetAddress1.trim() || !venueCity.trim() || !venueRegion.trim() || !venuePostalCode.trim() || !venueCountry.trim()}>
              Save Venue
            </Button>
          </Col>
        </Row>

        <Row style={{ marginTop: '22px' }}>
          <Col sm={12}>
            <div className="venues-saved-list">
              {venues.length === 0 ? (
                <div className="venues-empty-state">No venues saved yet.</div>
              ) : venues.map((venue, index) => (
                <div className="venue-saved-card" key={venue.id || `${venue.name}-${index}`}>
                  <button
                    type="button"
                    className="venue-saved-remove"
                    onClick={() => this.removeVenue(index)}
                    aria-label={`Remove ${venue.name || 'venue'}`}
                    title="Remove venue"
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                  <div>
                    <div className="venue-saved-name">{venue.name}</div>
                    <div className="venue-saved-address">
                      {[
                        venue.street_address_1,
                        venue.street_address_2,
                        [venue.city, venue.region, venue.postal_code].filter(Boolean).join(', '),
                        venue.country,
                        ].filter(Boolean).map((line, lineIndex) => (
                          <div key={`${venue.id || index}-line-${lineIndex}`}>{line}</div>
                        ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: '20px' }}>
          {
            this.state.spinner ?
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
            :
            this.state.confirm ?
              <Col sm={3} className="pull-right">
                <div className="email-sent pull-right" style={{display: 'flex'}}>
                  <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                  <p className="email-text" style={{verticalAlign: "super"}}>Profile Updated</p>
                </div>
              </Col>
            :
              <Fragment>
                <Col sm={3} className="pull-right">
                  {this.renderSaveButton('button2', 'Save Changes')}
                </Col>
              </Fragment>
          }
        </Row>
      </form>
    )
  }

  renderEmailTemplates = () => {
    const templates = this.getEmailTemplateList()
    const selectedTemplate = this.getSelectedEmailTemplate()

    return (
      <form className="padded">
        <div style={{ marginBottom: '14px', color: '#222', fontSize: '0.95rem', lineHeight: 1.5 }}>
          Select a template on the left, then edit the subject and body in place. Press Enter for a new paragraph.
        </div>
        <Row>
          <Col sm={4}>
            {templates.map((template) => {
              const isSelected = selectedTemplate && template.key === selectedTemplate.key
              return (
                <div
                  key={template.key}
                  onClick={() => this.handleEmailTemplateSelect(template.key)}
                  style={{
                    marginBottom: '12px',
                    padding: '14px 16px',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    border: isSelected ? '1px solid #5563b8' : '1px solid #d7d7d7',
                    background: isSelected ? '#eef1ff' : '#ffffff',
                    boxShadow: isSelected ? '0 10px 24px rgba(85,99,184,0.12)' : 'none',
                  }}
                >
                  <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '4px', color: '#111' }}>{template.label}</div>
                  <div style={{ fontSize: '0.88rem', color: '#555' }}>
                    {template.key === 'parent_registration_confirmation' && 'Sent to parents after a registration is completed.'}
                    {template.key === 'admin_registration_confirmation' && 'Sent to the organization when a registration is recorded.'}
                    {template.key === 'parent_waitlist_confirmation' && 'Sent to parents when a registration lands on the waitlist.'}
                  </div>
                </div>
              )
            })}
          </Col>
          <Col sm={8}>
            {selectedTemplate ? (
              <div
                style={{
                  padding: '16px',
                  borderRadius: '12px',
                  background: '#ffffff',
                  border: '1px solid #d7d7d7',
                }}
              >
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <ControlLabel style={{ color: '#111' }}>Subject</ControlLabel>
                      <FormControl
                        className="opaque-grey"
                        type="text"
                        value={selectedTemplate.subject || ''}
                        onChange={(e) => this.updateEmailTemplate(selectedTemplate.key, 'subject', e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <FormGroup>
                      <ControlLabel style={{ color: '#111' }}>Email Body</ControlLabel>
                      <FormControl
                        className="opaque-grey"
                        componentClass="textarea"
                        rows={16}
                        value={selectedTemplate.body || ''}
                        onChange={(e) => this.updateEmailTemplate(selectedTemplate.key, 'body', e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            ) : null}
          </Col>
        </Row>
        <Row style={{ marginTop: '20px' }}>
          {
            this.state.spinner ?
              <Col sm={3} className="pull-right">
                <div className="enrolment-loader pull-right"></div>
              </Col>
            :
            this.state.confirm ?
              <Col sm={3} className="pull-right">
                <div className="email-sent pull-right" style={{display: 'flex'}}>
                  <FontAwesomeIcon icon={faCheck} color='green' size="2x"/>
                  <p className="email-text" style={{verticalAlign: "super"}}>Profile Updated</p>
                </div>
              </Col>
            :
              <Fragment>
                <Col sm={3} className="pull-right">
                  {this.renderSaveButton('button2', 'Save Changes')}
                </Col>
              </Fragment>
          }
        </Row>
      </form>
    )
  }

  render() {
    const { activeTab } = this.state
    return (
      <div className="full-page">
        <HamburgerNavbar key={this.hamburgerKey}/>
        <div className="body-wrapper">
          <div className="dashboard-header-shell">
            <div className="programs-page-hero">
              <div className="programs-page-copy">
                <div className="programs-page-kicker">Admin Console</div>
                <h2 className="pagetitle programs-page-title">Profile</h2>
              </div>
            </div>
          </div>
          <div className="organization-tabs-wrapper">
            <Tabs
              id="organization-tabs"
              defaultActiveKey={activeTab}
              onSelect={this.handleTabSelect}
              className="organization-tabs"
            >
              <Tab eventKey="business" title="Business Details" />
              <Tab eventKey="waivers" title="Waivers" />
              <Tab eventKey="custom-fields" title="Custom Fields" />
              <Tab eventKey="program-types" title="Program Types" />
              <Tab eventKey="venues" title="Venues" />
              <Tab eventKey="merchandise" title="Merchandise" />
              <Tab eventKey="landing-page" title="Landing Page" />
              <Tab eventKey="integrations" title="Integrations" />
              <Tab eventKey="billing" title="Billing" />
              <Tab eventKey="email-templates" title="Email Templates" />
            </Tabs>
            <div className="dashboard-box">
              <div className="organization-tab-content">
                {activeTab === 'business' && this.renderBusinessDetails()}
                {activeTab === 'waivers' && this.renderWaivers()}
                {activeTab === 'custom-fields' && this.renderCustomFields()}
                {activeTab === 'program-types' && this.renderProgramTypes()}
                {activeTab === 'venues' && this.renderVenues()}
                {activeTab === 'merchandise' && this.renderMerchandise()}
                {activeTab === 'landing-page' && this.renderLandingPage()}
                {activeTab === 'integrations' && this.renderIntegrations()}
                {activeTab === 'billing' && this.renderBilling()}
                {activeTab === 'email-templates' && this.renderEmailTemplates()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default organizationForm;
